module.exports = __webpack_public_path__ + "images/patterns/dark/WaveSquare.9810752287610a74caed.svg";